(function () { if (window.__offerTimerInterval) clearInterval(window.__offerTimerInterval); function tick() { const els = document.querySelectorAll(".offer-timer"); if (!els.length) return; const now = new Date(); const end = new Date(); end.setHours(1, 0, 0, 0); if (now >= end) end.setDate(end.getDate() + 1); const diff = Math.max(0, end - now); const h = Math.floor(diff / 1000 / 60 / 60); const m = Math.floor(diff / 1000 / 60) % 60; const s = Math.floor(diff / 1000) % 60; const txt = String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0") + ":" + String(s).padStart(2, "0"); els.forEach(el => (el.textContent = txt)); } tick(); window.__offerTimerInterval = setInterval(tick, 1000); })();

function removeItem(id) { 
    document.querySelector('#'+id).click(); 
}

(function () {
    const ENDPOINT = '/cart/add.js';

    const _fetch = window.fetch;
    window.fetch = async function (input, init = {}) {
    const url = typeof input === 'string' ? input : input.url;
    const body = init.body;
    if (!url || !url.includes(ENDPOINT) || !(body instanceof FormData)) {
        return _fetch.apply(this, arguments);
    }
    const res = await _fetch.apply(this, arguments);
    try {
        const data = await res.clone().json();
        window.QPActionATC(data.id, data.title, data.handle, data.presentment_price, window.Shopify.currency.active);
    } catch (e) {}
    return res;
    };
})();

function addUpsellToCart(button) {
    const variantId = button.dataset.variantId;
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>';
    button.classList.add('upsell__add--added');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', cartDrawer.getSectionsToRender().map(s => s.id));
    formData.append('sections_url', window.location.pathname);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(routes.cart_add_url, config)
    .then(r => r.json())
    .then(response => {
        if (!response.status) {
        cartDrawer.renderContents(response);
        }
    })
    .catch(error => {
        console.error('Erreur ajout upsell:', error);
        button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M12 5v14m-7-7h14"/></svg>';
        button.classList.remove('upsell__add--added');
    });
}